import { IconButton } from '@chakra-ui/react'
import { useSidebar } from '@saas-ui/react'

import { LayoutSidebarLeftCollapseIcon } from './icons/layout-sidebar-left-collapse-icon'
import { LayoutSidebarLeftExpandIcon } from './icons/layout-sidebar-left-expand-icon'

export function SidebarTrigger() {
  const { open, setMode, mode, setOpen, isMobile } = useSidebar()

  if (open && !isMobile) {
    return null
  }

  return (
    <IconButton
      variant="ghost"
      size="xs"
      aria-label={open ? 'Collapse sidebar' : 'Expand sidebar'}
      onClick={() => {
        if (!isMobile && mode === 'flyout') {
          setMode('collapsible')
        }
        setOpen((prev) => !prev)
      }}
    >
      {open ? (
        <LayoutSidebarLeftCollapseIcon size="1.1rem" />
      ) : (
        <LayoutSidebarLeftExpandIcon size="1.1rem" />
      )}
    </IconButton>
  )
}
